export const customData = (_config, data) => {
  const custom = {};
  let changed = false;

  if (data.custom) {
    Object.entries(data.custom).forEach(([key, value]) => {
      changed = true;
      custom[`custom:${key}`] = value;
    });
  }

  return changed ? custom : null;
};